export class EvkFirmaModel {

    tipoInterviniente: Array<string>;
    categoriaInterviniente: Array<string>;
    requerido: string;
    titulo: string;
}
